import { ListMasterCategories } from "@/graphql/queries.js";
import { generateClient } from "aws-amplify/api";
const client = generateClient();
export const GetAllMasterCategories = {
  data() {
    return {
      overlay: false,
      noDataText: "",
      GetAllMasterCategoriesList: [],
      GetAllMasterCategoriesListFilter: [],
    };
  },
  methods: {
    async GetAllMasterCategoriesMethod() {
      try {
        this.overlay = true;
        let result = await client.graphql({
          query: ListMasterCategories,
          variables: {},
        });

        this.GetAllMasterCategoriesList = JSON.parse(
          result.data.ListMasterCategories
        ).data.items;
        this.overlay = false;
      } catch (error) {
        this.overlay = false;
        this.GetAllMasterCategoriesList = [];
        this.noDataText = error.errors[0].message;
      }
    },
  },
};
